import Model from '/lib/model'

export default \
class StripeConnectPermission extends Model
  @className: 'StripeConnectPermission'
  @belongsTo 'user',  model: 'User'
